import Model from '../Model'
import * as math from "mathjs";
import {isNull} from "lodash";

export default class ContractedWorks extends Model {
    static updateController = new AbortController();

    static async find(packageReference) {
        const data = await Http.get(route('api.v2.commercial-management.contracted-works', {packageReference: packageReference}), {})
        return this.make(data)
    }

    async reload() {
        let contract = await ContractedWorks.find(this.id)
        Object.assign(this, contract)
    }

    async updateProposal(proposal = {}) {
        ContractedWorks.updateController.abort()
        ContractedWorks.updateController = new AbortController();
        const url = route('api.v2.commercial-management.contracted-works.proposal.store', {packageReference: this.packageReference})
        await Http.send('put', url, proposal, {
            signal: ContractedWorks.updateController.signal
        }).catch(err => {
        })
        const data = await ContractedWorks.find(this.packageReference)
        Object.assign(this, data)
    }

    async clearProposal() {
        ContractedWorks.updateController.abort()
        ContractedWorks.updateController = new AbortController();
        const url = route('api.v2.commercial-management.contracted-works.proposal.delete', {packageReference: this.packageReference})
        await Http.send('delete', url, {
            signal: ContractedWorks.updateController.signal
        }).catch(err => {
        })
        const data = await ContractedWorks.find(this.packageReference)
        Object.assign(this, data)
    }

    async acceptProposal(name, comments) {
        const url = route('api.v2.commercial-management.contracted-works.proposal.accept', {packageReference: this.packageReference})
        const o = await Http.post(url, {name: name, comments: comments})
    }

    static async reset(packageReference) {
        const url = route('api.v2.commercial-management.contracted-works.reset', {packageReference: packageReference})
        const o = await Http.post(url, {})
    }

    setAttributes(attributes) {
        attributes.percent = math.round(attributes.ratio * 100) + '%'
        let setComponent = (obj) => {
            if (obj) {
                obj.scopeOfWorks.forEach((section) => {
                    section.tasks.forEach((task) => {
                        task.items.forEach((item) => {
                            if (item.importedComponentBuildup) {
                                item.importedComponentBuildup.materials.concat(item.importedComponentBuildup.labour, item.importedComponentBuildup.fixedCosts).forEach((m) => {
                                    let component = item.importedComponentBuildup.components.find((i) => i.id === m.componentId);
                                    if (component) {
                                        m.component = component
                                    }
                                })

                            }
                        })
                    })
                })
            }
        }
        super.setAttributes(attributes)
        setComponent(attributes.initialContract)
        setComponent(attributes.proposal)
        attributes.variations.forEach((v) => {
            setComponent(v)
        })
        this.buildTokens()
    }

    buildTokens() {
        let tokens = [
            this.date,
            this.id,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    getProposal() {
        if (this.proposal) {
            return this.proposal
        } else if (this.variations.length > 0) {
            return this.variations[this.variations.length - 1]
        } else {
            return this.initialContract
        }
    }

    disableSnapshots = false

    addSnapshot() {
        if (this.disableSnapshots) return
        let store = this.getSnapshotStore()
        let data = JSON.stringify(this.getProposal())
        if ((!store.states.length) || (store.states[store.states.length - 1] !== data)) {
            store.states.push(data);
            this.putSnapshotStore(store)
            eventBus.$emit('contracted-works-history-state-updated', {contractedWorks: this, states: store.states})
        }
    }

    clearSnapshots(fromPosition, count = null) {
        const store = this.getSnapshotStore()
        store.states.splice(fromPosition, isNull(count) ? store.states.length - fromPosition : count)
        this.putSnapshotStore(store);
    }

    getSnapshotStore() {
        if (!this.localStateStorage) {
            this.localStateStorage = {}
        }
        if (!this.localStateStorage['contracted-works-history:' + this.id]) {
            this.localStateStorage['contracted-works-history:' + this.id] = {states: []}
        }
        return this.localStateStorage['contracted-works-history:' + this.id]
    }

    putSnapshotStore(store) {
        this.localStateStorage['contracted-works-history:' + this.id] = store;
    }
}
